module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226713366_05_part1"
    }
  }, [_vm._v("PART IV: NARRATED TIME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226713366_06_int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226713366_07_sec1"
    }
  }, [_vm._v("SECTION 1: THE APORETICS OF TEMPORALITY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226713366_08_ch1"
    }
  }, [_vm._v("1. The Time of the Soul and the Time of the World: The Dispute between Augustine and Aristotle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226713366_09_ch2"
    }
  }, [_vm._v("2. Intuitive Time or Invisible Time? Husserl Confronts Kant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_10_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Temporality, Historicality, Within-Time-Ness: Heidegger and the “Ordinary” Concept of Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_11_sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECTION 2: POETICS OF NARRATIVE: HISTORY, FICTION, TIME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_12_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Between Lived Time and Universal Time: Historical Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_13_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Fiction and Its Imaginative Variations on Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_14_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Reality of the Past")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_15_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The World of the Text and the World of the Reader")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_16_ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Interweaving of History and Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_17_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Should We Renounce Hegel?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_18_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Towards a Hermeneutics of Historical Consciousness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_19_con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_20_notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_21_bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226713366_22_index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0df155a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780226713366_04_toc.vue
// module id = 63
// module chunks = 0